// =====================================================================
// billingBrandConfig — CAPA DE MARCA (PROTECTED en el sync)
// ---------------------------------------------------------------------
// Esta es la versión de IMPULZA. Cada app (Impulza / Gastify) mantiene la
// suya. El núcleo de cobro (useSubscriptionStatus, astropayService,
// páginas de suscripción) la importa por inyección y NO debe hardcodear
// nada de marca, precios, pasarela ni credenciales.
//
// Regla del plan: en Impulza el módulo de cobro queda INACTIVO por
// defecto (flag por organización apagado) y en modo SANDBOX.
// =====================================================================

export const BILLING_BRAND = {
  // Identidad
  brandName: 'Impulza',
  supportContact: 'soporte de Impulza',

  // Flags por organización (deben existir en ALL_MODULES de organizationModules.js,
  // y NO estar en ningún PLAN_PRESET → apagados por defecto en todas las orgs).
  billingFlag: 'suscripcion-billing',
  onboardingFlag: 'onboarding-guiado',

  // Pasarela de cobro del abono
  paymentProvider: 'mercadopago', // 'mercadopago' | 'astropay'
  sandbox: false,                 // Producción. El token real vive como secret
                                  // MERCADOPAGO_ACCESS_TOKEN en el Supabase de Impulza.

  // URLs de retorno post-checkout (relativas al sistema)
  returnPath: '/sistema/suscripcion/estado',

  // Moneda mostrada por defecto (el precio real sale de subscription_pricing)
  currency: 'ARS',
};

const PROVIDER_META = {
  mercadopago: { provider: 'mercadopago', label: 'MercadoPago', short: 'MP' },
  astropay:    { provider: 'astropay',    label: 'AstroPay',    short: 'AstroPay' },
};

export function getSubscriptionPaymentProviderMeta(provider) {
  return PROVIDER_META[provider] || PROVIDER_META[BILLING_BRAND.paymentProvider] || PROVIDER_META.mercadopago;
}

// =====================================================================
// Catálogo público de planes (marca). Estructura compartida con el
// núcleo (usePublicPlans), pero SIN precios reales: en Impulza son
// placeholders (price_monthly: 0). El precio real sale de la DB
// (subscription_pricing / subscription_plans) cuando el cobro se activa.
// =====================================================================
export const PUBLIC_PLAN_ORDER = ['basic', 'premium', 'enterprise'];

export const PUBLIC_PLAN_FALLBACKS = {
  basic: {
    marketingName: 'Plan Arranque',
    badge: 'Operación esencial',
    audience: 'Para locales chicos o negocios en su primera etapa de orden.',
    summary: 'Ventas, caja, clientes y stock en una sola rutina de trabajo.',
    price_monthly: 0,
    operation_limit: 500,
    modules: ['ventas-pos', 'ventas-historial', 'caja', 'clientes', 'productos', 'inventario', 'gastos'],
    highlights: ['Ventas y caja en un mismo flujo', 'Stock en tiempo real', 'Clientes y gastos básicos'],
    cta: 'Empezar con orden',
  },
  premium: {
    marketingName: 'Plan Control',
    badge: 'Crecimiento con método',
    audience: 'Para negocios con más movimiento, compras frecuentes y facturación.',
    summary: 'Compras, facturación y tesorería operativa sin depender de planillas.',
    price_monthly: 0,
    operation_limit: 2500,
    modules: ['ventas-pos', 'ventas-historial', 'caja', 'clientes', 'facturacion', 'productos', 'inventario',
      'compras-nueva', 'pedido-sugerido', 'compras', 'proveedores', 'bancos', 'tesoreria-cobranzas', 'tesoreria-pagos', 'gastos'],
    highlights: ['Compras y reposición', 'Facturación integrada', 'Tesorería operativa'],
    cta: 'Escalar con control',
  },
  enterprise: {
    marketingName: 'Plan Dirección',
    badge: 'Estrategia completa',
    audience: 'Para producción, multiunidad o dueños que deciden con números reales.',
    summary: 'Producción, flujo de fondos y control de rentabilidad de punta a punta.',
    price_monthly: 0,
    operation_limit: 0,
    modules: ['ventas-pos', 'ventas-historial', 'caja', 'clientes', 'facturacion', 'productos', 'inventario',
      'compras-nueva', 'pedido-sugerido', 'compras', 'proveedores', 'bancos', 'tesoreria-cobranzas', 'tesoreria-pagos', 'gastos',
      'produccion-registrar', 'pedidos-produccion', 'recetas', 'rentabilidad-ventas', 'gestion-costos', 'flujo-fondos', 'conciliacion-bancaria'],
    highlights: ['Producción y recetas', 'Flujo de fondos', 'Control de rentabilidad'],
    cta: 'Dirigir con margen',
  },
};

export const DEFAULT_TRIAL_DAYS = 14;

export default BILLING_BRAND;
